module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-28.2d200ca3.png";